import React from 'react' 

function Contactus() {

    return (
    
    <h1>Contactus</h1>
  
    );
  }
  export default Contactus;
